export const CLEAR_STRIPE_PAYMENT_INFOS = 'CLEAR_STRIPE_PAYMENT_INFOS';

export const clearStripePaymentInfos = () => ({
  type: CLEAR_STRIPE_PAYMENT_INFOS
});
